// extracted by mini-css-extract-plugin
export default {"summaryBenefits":"kmtZjg","summaryBenefitsText":"ZNhGdQ","summaryBenefitsInfoIcon":"BUyCi7","summaryBenefitsTooltip":"ZtxfLC"};